'use strict';

var $ = require('jquery');
var offcanvasdialog = require('../components/offcanvasdialog');
var availabiltyReminder = require('../pages/product/availabilityReminder');
var bonusProductFlyin = require('../pages/cart/bonusproductflyin');
var newsletterFlyin = require('./newsletterflyin');
var mobilemenuFlyin = require('./mobilemenuflyin');
var footerCountrySwitcherFlyin = require('./footercountryswitcherflyin');
var storeInventory = require('./storeInventory');
var productsizeutil = require('../components/product/productsizeutil');
var toggle = require('../components/toggle');
var quickShop = require('../components/product/quickshop');
var addToCart = require('../pages/product/addToCart');
var validInputIndicator = require('../validation/valid-input-indicator');
const cartoverlay = require('../components/checkout/cartoverlay');
const ingredientsFlyin = require('./ingredientsflyin');

/**
 * @param {Event} e - event
 */
function callmembersOnlyFlyin(e) {
    const membersOnlyFlyin = require('../flyins/membersonlyflyin');
    membersOnlyFlyin.init(e.target);
}

var flyin = {
    init: function (options) {
        if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            $('html').addClass('ie');
        }

        options = options || {};
        $(document).ready(function () {
            var $productPromotionAccordeon = $('.product-promotion-accordeon');
            var $flyinLinkFreebiePromotion = $('.flyin-link-freebie-promotion');

            if (
                $productPromotionAccordeon.length &&
                $flyinLinkFreebiePromotion.length &&
                $flyinLinkFreebiePromotion.attr('href') === '#'
            ) {
                $flyinLinkFreebiePromotion.attr('href', $productPromotionAccordeon.data('flyin-url'));
            }

            // simple content dialogs with overlay and additional class
            $.each(
                {
                    'fylin-link-refill': 'flyin-product-info',
                    'flyin-product-info-size': 'flyin-product-info',
                    'flyin-product-info-width': 'flyin-product-info foot-width',
                    'flyin-product-info-width-size': 'flyin-product-info foot-width-size'
                },
                function (trigger, additionalClass) {
                    offcanvasdialog.init(
                        trigger,
                        {
                            overlay: true,
                            closeOnX: true,
                            additionalClass: additionalClass
                        },
                        function ($triggerButton, $flyinContainer) {
                            bonusProductFlyin($flyinContainer);

                            var $content = $flyinContainer.find('.ocd-content > *:first');
                            $content.attr('tabindex', '0');
                            $content.focus();
                            $flyinContainer.find('.close-button a').on(
                                'click',
                                function (event) {
                                    event.preventDefault();
                                    this.hide();
                                }.bind(this)
                            );
                        }
                    );
                }
            );

            offcanvasdialog.init(
                'flyin-link-freebie-promotion',
                {
                    overlay: true,
                    reloadContentAlways: true,
                    additionalClass: 'fly-in-dialogue-freebie-promotion'
                },
                function ($triggerButton, $flyinContainer) {
                    bonusProductFlyin($flyinContainer);
                    $('.flyin-link-freebie-promotion').blur();
                    $flyinContainer.find('.button.close').on(
                        'click',
                        function (event) {
                            event.preventDefault();
                            this.hide();
                        }.bind(this)
                    );
                }
            );

            offcanvasdialog.init(
                'flyin-product-set-details',
                {
                    // eslint-disable-line no-unused-vars
                    overlay: true,
                    reloadContentAlways: true,
                    additionalClass: 'quick-shop quick-shop-set',
                    closeOnX: true
                },
                function ($triggerButton, $flyinContainer) {
                    toggle.init();
                }
            );

            availabiltyReminder.init(options);

            offcanvasdialog.init(
                'fylin-link-avaliability',
                {
                    overlay: true,
                    reloadContentAlways: true,
                    closeOnX: false,
                    additionalClass: 'fly-in-dialogue-avaliability member-shop-fly-in'
                },
                function ($triggerButton, $flyinContainer) {
                    availabiltyReminder.initFlyIn($flyinContainer);
                    $flyinContainer.on('click', 'button[type="button"]', e => {
                        newsletterFlyin.validateNewsletterFlyinForm(
                            $flyinContainer,
                            e,
                            false,
                            false,
                            '.ocd-content',
                            '.availability-newsletter-heading'
                        );
                    });

                    validInputIndicator.initValidIndicatorEvent({container: $flyinContainer});

                    $('.fly-in-dialogue-avaliability .ocd-content').scrollTop();

                    $('body').on(
                        'click',
                        '.availability-success .close, .ocd-close',
                        function () {
                            this.hide();
                        }.bind(this)
                    );
                    $('.availability-reminder').on(
                        'click',
                        '.size-region a, .attribute.size .form-row-radio.region-select',
                        function () {
                            productsizeutil.changeSizeRegion(this);
                        }
                    );
                }
            );

            if (sessionStorage.getItem('signInForAvailabilityReminder')) {
                $(
                    `.fylin-link-avaliability[data-id="${sessionStorage.getItem('signInForAvailabilityReminder')}"]`
                ).click();
            }

            newsletterFlyin.init();
            mobilemenuFlyin.init();
            footerCountrySwitcherFlyin.init();
            cartoverlay.init();
            quickShop.init();
            if (sessionStorage.getItem('signInToBuyLogin') && sessionStorage.getItem('signInToBuyProduct') != '') {
                var pid = sessionStorage.getItem('signInToBuyProduct');
                sessionStorage.removeItem('signInToBuyLogin');
                sessionStorage.removeItem('signInToBuyProduct');
                addToCart.addProductAfterLogin(pid);
            }
            storeInventory.init();
            ingredientsFlyin.init();

            $('body').on(
                'click',
                '.flyin-store-finder, .flyin-product-info-size, .flyin-product-info-width, .flyin-product-info-width-size, .fylin-link-avaliability, .flyin-product-set-details, .fylin-link-refill',
                function () {
                    $('.ocd-overlay').addClass('active right');
                }
            );

            $('body').on(
                'click',
                '.flyin-product-info .ocd-close, .fly-in-dialogue-avaliability .ocd-close, .fly-in-dialogue-avaliability .close',
                function () {
                    $('.ocd-overlay').removeClass('active right');
                }
            );

            $('body').on('click', '.find-your-fit-tab:not(.selected)', function () {
                $('.find-your-fit-tab').toggleClass('selected');
                $('.find-your-fit-content').toggleClass('active');
            });

            $('body').on('click', '#members-only-flyin', callmembersOnlyFlyin);
            $('body').on('click', '.members-only-flyin-returns', callmembersOnlyFlyin);
        });
    }
};

exports.init = flyin.init;
